/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { vendorWorkspaceUserControllerCreateMember } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-create-member';
import { VendorWorkspaceUserControllerCreateMember$Params } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-create-member';
import { vendorWorkspaceUserControllerDelegate } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-delegate';
import { VendorWorkspaceUserControllerDelegate$Params } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-delegate';
import { vendorWorkspaceUserControllerDeportUser } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-deport-user';
import { VendorWorkspaceUserControllerDeportUser$Params } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-deport-user';
import { vendorWorkspaceUserControllerFindUserById } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-find-user-by-id';
import { VendorWorkspaceUserControllerFindUserById$Params } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-find-user-by-id';
import { vendorWorkspaceUserControllerFindUsersByWorkspaceId } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-find-users-by-workspace-id';
import { VendorWorkspaceUserControllerFindUsersByWorkspaceId$Params } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-find-users-by-workspace-id';
import { vendorWorkspaceUserControllerSearchOffset } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-search-offset';
import { VendorWorkspaceUserControllerSearchOffset$Params } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-search-offset';
import { vendorWorkspaceUserControllerUpdateUser } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-update-user';
import { VendorWorkspaceUserControllerUpdateUser$Params } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-update-user';
import { vendorWorkspaceUserControllerWithdraw } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-withdraw';
import { VendorWorkspaceUserControllerWithdraw$Params } from '../fn/vendor-workspace-user/vendor-workspace-user-controller-withdraw';
import { VendorWorkspaceUserDto } from '../models/vendor-workspace-user-dto';

@Injectable({ providedIn: 'root' })
export class VendorWorkspaceUserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorWorkspaceUserControllerFindUsersByWorkspaceId()` */
  static readonly VendorWorkspaceUserControllerFindUsersByWorkspaceIdPath = '/api/vendorWorkspaceUser/{id}/users';

  /**
   * 입점사 ID 기반 구성원 목록 조회.
   *
   * 입점사 ID를 기반으로 구성원 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceUserControllerFindUsersByWorkspaceId()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerFindUsersByWorkspaceId$Response(params: VendorWorkspaceUserControllerFindUsersByWorkspaceId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorWorkspaceUserDto>>> {
    return vendorWorkspaceUserControllerFindUsersByWorkspaceId(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 ID 기반 구성원 목록 조회.
   *
   * 입점사 ID를 기반으로 구성원 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceUserControllerFindUsersByWorkspaceId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerFindUsersByWorkspaceId(params: VendorWorkspaceUserControllerFindUsersByWorkspaceId$Params, context?: HttpContext): Observable<Array<VendorWorkspaceUserDto>> {
    return this.vendorWorkspaceUserControllerFindUsersByWorkspaceId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorWorkspaceUserDto>>): Array<VendorWorkspaceUserDto> => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceUserControllerCreateMember()` */
  static readonly VendorWorkspaceUserControllerCreateMemberPath = '/api/vendorWorkspaceUser/{id}/users';

  /**
   * 입점사 구성원 직접 생성.
   *
   * 관리자가 직접 정보를 입력하여 구성원 계정을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceUserControllerCreateMember()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceUserControllerCreateMember$Response(params: VendorWorkspaceUserControllerCreateMember$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
    return vendorWorkspaceUserControllerCreateMember(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 구성원 직접 생성.
   *
   * 관리자가 직접 정보를 입력하여 구성원 계정을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceUserControllerCreateMember$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceUserControllerCreateMember(params: VendorWorkspaceUserControllerCreateMember$Params, context?: HttpContext): Observable<VendorWorkspaceUserDto> {
    return this.vendorWorkspaceUserControllerCreateMember$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceUserDto>): VendorWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceUserControllerSearchOffset()` */
  static readonly VendorWorkspaceUserControllerSearchOffsetPath = '/api/vendorWorkspaceUser/search/offset';

  /**
   * 입점사 구성원 오프셋 기반 검색.
   *
   * 입점사 구성원을 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceUserControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerSearchOffset$Response(params: VendorWorkspaceUserControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items'?: Array<VendorWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
}>> {
    return vendorWorkspaceUserControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 구성원 오프셋 기반 검색.
   *
   * 입점사 구성원을 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceUserControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerSearchOffset(params: VendorWorkspaceUserControllerSearchOffset$Params, context?: HttpContext): Observable<{
'items'?: Array<VendorWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
}> {
    return this.vendorWorkspaceUserControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'items'?: Array<VendorWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
}>): {
'items'?: Array<VendorWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceUserControllerFindUserById()` */
  static readonly VendorWorkspaceUserControllerFindUserByIdPath = '/api/vendorWorkspaceUser/{id}/users/{userId}';

  /**
   * 입점사 구성원 ID 기반 조회.
   *
   * 입점사 구성원을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceUserControllerFindUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerFindUserById$Response(params: VendorWorkspaceUserControllerFindUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
    return vendorWorkspaceUserControllerFindUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 구성원 ID 기반 조회.
   *
   * 입점사 구성원을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceUserControllerFindUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerFindUserById(params: VendorWorkspaceUserControllerFindUserById$Params, context?: HttpContext): Observable<VendorWorkspaceUserDto> {
    return this.vendorWorkspaceUserControllerFindUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceUserDto>): VendorWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceUserControllerUpdateUser()` */
  static readonly VendorWorkspaceUserControllerUpdateUserPath = '/api/vendorWorkspaceUser/{id}/users/{userId}';

  /**
   * 입점사 구성원 역할 변경.
   *
   * 입점사 구성원의 역할을 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceUserControllerUpdateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceUserControllerUpdateUser$Response(params: VendorWorkspaceUserControllerUpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
    return vendorWorkspaceUserControllerUpdateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 구성원 역할 변경.
   *
   * 입점사 구성원의 역할을 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceUserControllerUpdateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceUserControllerUpdateUser(params: VendorWorkspaceUserControllerUpdateUser$Params, context?: HttpContext): Observable<VendorWorkspaceUserDto> {
    return this.vendorWorkspaceUserControllerUpdateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceUserDto>): VendorWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceUserControllerDelegate()` */
  static readonly VendorWorkspaceUserControllerDelegatePath = '/api/vendorWorkspaceUser/{id}/users/{userId}/delegate';

  /**
   * 입점사 대표 위임.
   *
   * 입점사 대표를 위임합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceUserControllerDelegate()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerDelegate$Response(params: VendorWorkspaceUserControllerDelegate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
    return vendorWorkspaceUserControllerDelegate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 대표 위임.
   *
   * 입점사 대표를 위임합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceUserControllerDelegate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerDelegate(params: VendorWorkspaceUserControllerDelegate$Params, context?: HttpContext): Observable<VendorWorkspaceUserDto> {
    return this.vendorWorkspaceUserControllerDelegate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceUserDto>): VendorWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceUserControllerWithdraw()` */
  static readonly VendorWorkspaceUserControllerWithdrawPath = '/api/vendorWorkspaceUser/{id}/withdraw';

  /**
   * 입점사 탈퇴.
   *
   * 입점사에서 탈퇴합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceUserControllerWithdraw()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerWithdraw$Response(params: VendorWorkspaceUserControllerWithdraw$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
    return vendorWorkspaceUserControllerWithdraw(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 탈퇴.
   *
   * 입점사에서 탈퇴합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceUserControllerWithdraw$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerWithdraw(params: VendorWorkspaceUserControllerWithdraw$Params, context?: HttpContext): Observable<VendorWorkspaceUserDto> {
    return this.vendorWorkspaceUserControllerWithdraw$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceUserDto>): VendorWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceUserControllerDeportUser()` */
  static readonly VendorWorkspaceUserControllerDeportUserPath = '/api/vendorWorkspaceUser/{id}/deport/{userId}';

  /**
   * 입점사 구성원 추방.
   *
   * 입점사 구성원을 추방합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceUserControllerDeportUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerDeportUser$Response(params: VendorWorkspaceUserControllerDeportUser$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
    return vendorWorkspaceUserControllerDeportUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 구성원 추방.
   *
   * 입점사 구성원을 추방합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceUserControllerDeportUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceUserControllerDeportUser(params: VendorWorkspaceUserControllerDeportUser$Params, context?: HttpContext): Observable<VendorWorkspaceUserDto> {
    return this.vendorWorkspaceUserControllerDeportUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorWorkspaceUserDto>): VendorWorkspaceUserDto => r.body)
    );
  }

}
